import React, { useEffect, useState } from 'react'
import EnduroMarketPage from 'src/pages/ReportsPages/ReportsBoard/CommercialsReportsPages/EnduroMarketPage'
import boardReportsService from 'src/services/boardReportsService'

const EnduroMarketContainer = () => {
  const [total, setTotals] = useState([])
  const [gTotal, setGTotals] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date())

  const reloadTotal = async () => {
    const response = await boardReportsService.getTotalMarkes(
      '11',
      selectedDate.getFullYear(),
    )
    setTotals(response)
  }

  const reloadGTotal = async () => {
    const response = await boardReportsService.getTotalMarketsGraphics(
      '11',
      selectedDate.getFullYear(),
    )
    setGTotals(response)
  }

  const handleDateChange = (value) => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadTotal()
    reloadGTotal()
  }, [selectedDate])

  return (
    <EnduroMarketPage
      total={total}
      gTotal={gTotal}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
    />
  )
}

export default EnduroMarketContainer
